/* eslint-disable max-len */
import React from 'react';

export default function Info() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" className="svg info">
			<path d="M7.5 15C3.4 15 0 11.6 0 7.5S3.4 0 7.5 0 15 3.4 15 7.5 11.6 15 7.5 15zm0-13C4.5 2 2 4.5 2 7.5S4.5 13 7.5 13 13 10.5 13 7.5 10.5 2 7.5 2z" /><path d="M7.5 3.9c.5 0 .9.4.9.9s-.4.8-.9.8-.9-.3-.9-.8.4-.9.9-.9zm-.7 3c0-.4.3-.8.8-.8s.8.3.8.8v3.7c0 .4-.3.8-.8.8s-.8-.4-.8-.9V6.9z" />
		</svg>
	);
}
